/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
import { combineReducers } from 'redux';

import signUpReducer from './signup-reducer';
import signInReducer from './signin-reducer';
import userReducer from './user-reducer';
import multiplosReducer from './multiplos-reducer';
import novoAbastecimentoReducer from './novoAbastecimento-reducer';

export const reducers = combineReducers({
  signUpReducer,
  signInReducer,
  userReducer,
  multiplosReducer,
  novoAbastecimentoReducer,
});
